"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHistoricalComparisonSpec = function (comparisonPeriod, message, numberOfPeriods) {
    return {
        type: 'HISTORICAL_COMPARISON',
        comparisonPeriod: comparisonPeriod,
        numberOfPeriods: (numberOfPeriods !== null && numberOfPeriods !== void 0 ? numberOfPeriods : 1),
        message: message,
    };
};
//# sourceMappingURL=HistoricalComparisonSpec.js.map